import * as Scrivito from "scrivito";
import metadataAttributes from "objs/_metadataAttributes";
import defaultPageAttributes from "objs/_defaultPageAttributes";

const DepartmentList = Scrivito.provideObjClass("DepartmentList", {
  attributes: {
    body: ["widgetlist", { only: "SectionWidget" }],
    ...metadataAttributes,
    ...defaultPageAttributes,
  },
  extractTextAttributes: ["body", "title", "subtitle"],
});

export default DepartmentList;
